import * as d3 from 'd3'
import httpManager from "../../util/common"

export default {
  props: ['oaid'],
  data() {
    return {
      report_date: null,
      total_gh1_2: 0,
      empty_data_pie_show: true,
      date_year: [

      ],
      source: '',
      // legends_show: false,
      loading: false
    }
  },
  methods: {
    // 设置时间筛选
    setDate() {
      let date = new Date
      let current_year = date.getFullYear()
      const current_month = date.getMonth()
      this.report_date = current_month <= 2 ? current_year - 2 : current_year - 1
      this.date_year = []
      for (let i = 0; i < 4; i++) {
        this.date_year.push( this.report_date - i)
      }
    },
    // 绘制饼状图
    drawPieChart(data, {
      name = ([x]) => x,
      value = ([, y]) => y,
      title,
      width = 640,
      height = 400,
      innerRadius = 0,
      outerRadius = Math.min(width, height) / 3,
      labelRadius = (innerRadius * 0.2 + outerRadius * 0.8),
      format = ",",
      names,
      colors,
      stroke = innerRadius > 0 ? "none" : "white",
      strokeWidth = 1,
      strokeLinejoin = "round",
      padAngle = stroke === "none" ? 1 / outerRadius : 0,
      fontsize = 10
    } = {}) {
      const N = d3.map(data, d => d.value ? d.value.toLocaleString() + 'tCO2e' : '')
      const V = d3.map(data, value)
      const I = d3.range(N.length).filter(i => !isNaN(V[i]))
      names = N

      // Chose a default color scheme based on cardinality.
      if (colors === undefined) colors = d3.schemeSpectral[names.size];
      if (colors === undefined) colors = d3.quantize(t => d3.interpolateSpectral(t * 0.8 + 0.1), names.size);

      // Construct scales.
      const color = d3.scaleOrdinal(names, colors);
      // Compute titles.
      if (title === undefined) {
        const formatValue = d3.format(format);
        title = i => `${N[i]}\n${formatValue(V[i])}`;
      } else {
        const O = d3.map(data, d => d);
        const T = title;
        title = i => T(O[i], i, data);
      }

      const arcs = d3.pie().padAngle(padAngle).sort(null).value(i => V[i])(I)
      const arc = d3.arc().innerRadius(innerRadius).outerRadius(outerRadius)
      const arcLabel = d3.arc().innerRadius(labelRadius).outerRadius(labelRadius)

      const svg = d3.create("svg")
        .attr("width", width)
        .attr("viewBox", [-width / 2, -height / 2, width, height])
        .attr("style", `width: ${width}px; height: ${height}px; height: intrinsic;`)// 让svg与其父盒子等大

      const pie = svg.selectAll("g")
        .data(arcs)
        .enter()
        .append("g")

      pie.append("path")
        .attr('fill', d => color(N[d.data]))
        .attr('d', arc)

      var V_sum = 0
      arcs.forEach(element => {
        V_sum += element.value
      })
      // 添加内部文字
      pie.append("text")
        .attr("font-weight", "bold")
        .attr("transform", d => {
          let x = arcLabel.centroid(d)[0] > 0 ? arcLabel.centroid(d)[0] * 0.3 : arcLabel.centroid(d)[0] * 1
          let y = arcLabel.centroid(d)[1] * 0.6
          return `translate(${[x, y]})`
        })
        .text(d => {
          if (d.value / V_sum < 0.30) return ''
          return N[d.data]
        })
        .call(text => text.append("tspan")
          .attr("x", 0)
          .attr("y", fontsize)
          .attr("font-weight", "normal")
          .text(d => {
            if (d.value / V_sum < 0.30) return ''
            return (d.value / V_sum * 100).toFixed(2) + '%'
          }))



      function getPixelLength(str, fontsize) {
        let curLen = 0
        let strLen = str.length
        for (let i = 0; i < str.length; i++) {
          const code = str.charCodeAt(i)
          const pixelLen = code > 255 ? fontsize : fontsize / 2
          curLen += pixelLen
        }
        return curLen
      }
      function midAngle(d) {
        return d.startAngle + (d.endAngle - d.startAngle) / 2
      }
      // 添加折线和文字
      pie.append("line")
        .attr("stroke", "black")
        .attr("x1", d => {
          if (d.value / V_sum > 0.3 || d.value == 0) return
          return arc.centroid(d)[0] * 2
        })
        .attr("y1", d => {
          if (d.value / V_sum > 0.3 || d.value == 0) return
          return arc.centroid(d)[1] * 2
        })
        .attr("x2", d => {
          if (d.value / V_sum > 0.3 || d.value == 0) return
          return arc.centroid(d)[0] * 2.2
        })
        .attr("y2", d => {
          if (d.value / V_sum > 0.3 || d.value == 0) return
          return arc.centroid(d)[1] * 2.2
        })
      pie.append("line")
        .attr("stroke", "black")
        .each(d => {
          d.textLine = {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0
          }
        })
        .attr('x1', d => {
          d.textLine.x1 = arc.centroid(d)[0] * 2.2
          if (d.value / V_sum > 0.3 || d.value == 0) return 0
          return d.textLine.x1
        })
        .attr('y1', d => {
          d.textLine.y1 = arc.centroid(d)[1] * 2.2
          if (d.value / V_sum > 0.3 || d.value == 0) return 0
          return d.textLine.y1
        })
        .attr('x2', d => {
          const strLen = getPixelLength(N[d.data], fontsize)
          const bx = arc.centroid(d)[0] * 2.5
          d.textLine.x2 = bx >= 0 ? bx + strLen : bx - strLen
          if (d.value / V_sum > 0.3 || d.value == 0) return 0
          return d.index === 2 ? -d.textLine.x2 : d.textLine.x2
        })
        .attr('y2', d => {
          d.textLine.y2 = arc.centroid(d)[1] * 2.2
          if (d.value / V_sum > 0.3 || d.value == 0) return 0
          return d.textLine.y2
        })
      pie.append('text')
        .attr('transform', d => {
          let x = (d.textLine.x1 + d.textLine.x2) / 2
          let y = d.textLine.y1
          y = y > 0 ? y + fontsize * 1.1 : y - fontsize * 0.4
          return d.index === 2 ? `translate(${-x * 2}, ${y})`: `translate(${x}, ${y})`
        })
        .style('text-anchor', d => midAngle(d) < Math.PI ? 'start' : 'end')
        .style('font-size', fontsize)
        .text(d => {
          if (d.value / V_sum > 0.3 || d.value == 0) return
          return (d.value / V_sum * 100).toFixed(2) + '%'
        })
      pie.append('text')
        .attr('transform', d => {
          let x = (d.textLine.x1 + d.textLine.x2) /2
          let y = d.textLine.y1
          y = y > 0 ? y + fontsize * 2 : y - fontsize * 2
          return d.index === 2 ? `translate(${-x * 2}, ${y})`: `translate(${x}, ${y})`
        })
        .style('text-anchor', d => midAngle(d) < Math.PI ? 'start' : 'end')
        .style('font-size', fontsize)
        .style("font-weight", "bold")
        .text(d => {
          if (d.value / V_sum > 0.3 || d.value == 0) return
          return N[d.data]
        })

      svg.append("g")
        .attr("font-family", "sans-serif")
        .attr("font-size")
      return Object.assign(svg.node(), { scales: { color } })
    },
    getCarbonData() {
      let self = this
      // self.legends_show = false
      self.pie_data[0].value = 0
      self.pie_data[1].value = 0
      self.pie_data[2].value = 0
      self.source = ''
      self.total_gh1_2 = 0
      let params = new Map()
      params.set("lang", this.$i18n.locale)
      if (self.report_date) {
        params.set("years", self.report_date)
      }
      // "66ed6c1d-a3e6-11ea-bc6e-54bf6471772d"
      if (self.oaid) {
        params.set("oaid", self.oaid)
      }
      self.loading = true
      const svgDom = self.$refs.pieChart.getElementsByTagName("svg")[0]
      if (svgDom) {
        svgDom.style.display = 'none'
      }
      httpManager('carbon', params)
        .then(response => {
          if (response.data.data && response.data.data.length > 0) {
            // svgDom.style('display', none)
            this.empty_data_pie_show = false
            let data = response.data.data[0]
            self.pie_data[0].value = data.ghg1_disclose
            self.pie_data[1].value = data.ghg2_disclose
            self.pie_data[2].value = data.ghg3_disclose
            self.total_gh1_2 = data.totalghg1_2
            if (data.source == 'Disclosure') {
              self.source = '披露值'
            } else if (data.source == 'Estimation') {
              self.source = '估算值'
            } else if (data.source == 'Uncovered')  {
              self.total_gh1_2 = 0
              self.source = '未覆盖'
            }
            let width = 650/20*getComputedStyle(window.document.documentElement)['font-size'].slice(0, 2)
            let height = 350/20*getComputedStyle(window.document.documentElement)['font-size'].slice(0, 2)
            if (data.ghg1_disclose || data.ghg2_disclose || data.ghg3_disclose) {
              // self.legends_show = true
              const pie_set = {
                name: d => d.name,
                value: d => d.value,
                colors: self.pie_data.map(d => d.color),
                height: height,
                width: width,
                fontsize: 12
              }
              const svg = self.drawPieChart(self.pie_data, pie_set)
              const div = document.getElementById("cd-pie-svg")
              var old_svg = document.querySelector("#cd-pie-svg svg")
              if(old_svg)
                div.removeChild(old_svg)
              div.appendChild(svg)
            }
            self.total_gh1_2 = self.total_gh1_2.toLocaleString()
          } else {
            this.empty_data_pie_show = true
          }
          self.loading = false
        }).catch(error => {
          console.log(error)
          self.loading = false
          this.empty_data_pie_show = true
        })
    }
  },
  created() {
    this.setDate()
  },
  mounted() {
    this.$nextTick(() => {
      this.getCarbonData()

    })
  },
  computed: {
    pie_data() {
      return [
        { key: '1', name: this.$t('carbon.GHG_emission_category_1'), value: '', color: '#4563b3' },
        { key: '2', name: this.$t('carbon.GHG_emission_category_2'), value: '', color: '#e1b93c' },
        { key: '3', name: this.$t('carbon.GHG_emission_category_3'), value: '', color: '#4c964b' }
      ]
    },
  }
}


// WEBPACK FOOTER //
// ./src/carbon/js/cd_pie_chart.js